import React from 'react';
import { usePageData } from '../../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../common/LoadingSpinner';

const PrivacyPolicySection = () => {
  const { data: privacyPage, isLoading, error } = usePageData('privacyPage');

  if (isLoading) {
    return (
      <section className="privacy-section">
        <div className="container">
          <LoadingSkeleton type="text" count={1} />
          <LoadingSkeleton type="card" count={5} />
        </div>
      </section>
    );
  }

  if (error || !privacyPage) {
    return (
      <section className="privacy-section">
        <div className="container">
          <h1>Privacy Policy</h1>
          <div className="last-updated">
            <span>Last Updated: {new Date().toLocaleDateString()}</span>
          </div>
          
          <div className="privacy-content">
            <div className="section">
              <h2>Our Commitment to Privacy</h2>
              <p>Your privacy is important to us. This privacy policy explains what personal data we collect from you, how we use it, and how we protect it.</p>
            </div>

            <div className="section">
              <h2>Information We Collect</h2>
              <p>We collect information you provide directly to us, such as when you create an account, build a resume, or contact us for support.</p>
              <ul>
                <li>Name and contact information</li>
                <li>Professional information for your resume</li>
                <li>Account credentials</li>
                <li>Communication preferences</li>
              </ul>
            </div>

            <div className="section">
              <h2>How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide and improve our services</li>
                <li>Personalize your experience</li>
                <li>Communicate with you about our services</li>
                <li>Ensure the security of our platform</li>
              </ul>
            </div>

            <div className="section">
              <h2>Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, please contact us at <a href="/contact">Contact US</a>.</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="privacy-section">
      <div className="container">
        <h1>{privacyPage.title}</h1>
        
        <div className="last-updated">
          <span>Last Updated: {new Date(privacyPage.last_updated).toLocaleDateString()}</span>
        </div>
        
        <div 
          className="privacy-content"
          dangerouslySetInnerHTML={{ __html: privacyPage.content }}
        />
      </div>
    </section>
  );
};

export default PrivacyPolicySection;